import type { FC, ReactElement } from "react";
import { useMemo } from "react";

import {
    FiltersChipOperatorItem,
    FiltersComplexChip,
} from "app/pages/sales-intelligence/common-components/filters-panel";

import type { IAppsSDKsFilterItem } from "../../types/commonFiltersDto";

type InclusionSdkChipProps = {
    item: IAppsSDKsFilterItem;
    onEdit: (item: IAppsSDKsFilterItem) => void;
    onDelete: (item: IAppsSDKsFilterItem) => void;
};

const InclusionSdkChip: FC<InclusionSdkChipProps> = ({ item, onEdit, onDelete }): ReactElement => {
    const renderContent = useMemo((): ReactElement[] => {
        const categoryItems = item.categories.map((category, i) => {
            return (
                <FiltersChipOperatorItem
                    key={category}
                    itemTitle={category}
                    operator={i > 0 ? item.operator : undefined}
                />
            );
        });

        const sdkItems = item.sdks.map((sdk: string, i: number) => {
            return (
                <FiltersChipOperatorItem
                    key={sdk}
                    itemTitle={sdk}
                    operator={categoryItems.length > 0 || i > 0 ? item.operator : undefined}
                />
            );
        });

        return [...categoryItems, ...sdkItems];
    }, [item]);

    return (
        <FiltersComplexChip
            title={{ key: `si.common.inclusions.${item.inclusion}` }}
            onActionClick={() => onEdit(item)}
            onRemove={() => onDelete(item)}
        >
            {renderContent}
        </FiltersComplexChip>
    );
};

export default InclusionSdkChip;
